import { Action } from 'redux';

import { IMetricInfo } from '../../../ts/models/IMetricInfo';
import { isClearMetricsDataCache } from '../../actions/spaces/MetricsDataCacheActions';
import { isUpdateMetricsDataSucceededAction } from '../../actions/spaces/UpdateMetricsActions';
import { MetricsDataCache } from '../../state/MetricsDataCache';

export const InitialMetricsDataCache: MetricsDataCache = {};
export function metricsDataCacheReducer(
  previousState: MetricsDataCache = InitialMetricsDataCache,
  action: Action = null
): MetricsDataCache {

  if (isUpdateMetricsDataSucceededAction(action)) {
    let newState = {...previousState};
    let metricUpdated = false;
    action.metrics.forEach((metric: IMetricInfo) => {
      if (metric.schema) {  // data came back for this metric
        newState[metric.id] = {
            dataPoints: metric.dataPoints,
            schema: metric.schema,
            dataRefreshedTimestamp: metric.dataRefreshedTimestamp,
            dataPointsRequested: metric.dataPointsRequested
          };
        metricUpdated = true;
      }
    });
    if (metricUpdated) {
      return newState;
    }
  } else if (isClearMetricsDataCache(action)) {
    previousState = InitialMetricsDataCache;
  }
  return previousState;
}
